import { render, staticRenderFns } from "./BtBackersChart.vue?vue&type=template&id=7584637a&scoped=true&"
import script from "./BtBackersChart.vue?vue&type=script&lang=js&"
export * from "./BtBackersChart.vue?vue&type=script&lang=js&"
import style0 from "./BtBackersChart.vue?vue&type=style&index=0&id=7584637a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7584637a",
  null
  
)

export default component.exports